module.exports = require("@mui/icons-material/Map");